var map = {
	"./1inch.png": 41096,
	"./aave.png": 46268,
	"./abt.png": 79190,
	"./aca.png": 49188,
	"./ace.png": 52512,
	"./ach.png": 45781,
	"./ada.png": 43469,
	"./aergo.png": 86547,
	"./aevo.png": 62442,
	"./agld.png": 26677,
	"./aidoge.png": 53628,
	"./akita.png": 56937,
	"./alcx.png": 53391,
	"./algo.png": 36700,
	"./alpha.png": 48965,
	"./ankr.png": 60707,
	"./ant.png": 79010,
	"./ape.png": 86725,
	"./api3.png": 73254,
	"./apt.png": 54444,
	"./ar.png": 95968,
	"./arb.png": 3008,
	"./ardr.png": 17174,
	"./arg.png": 9005,
	"./ark.png": 16017,
	"./arty.png": 98597,
	"./ast.png": 79625,
	"./astr.png": 18911,
	"./ath.png": 90876,
	"./atom.png": 590,
	"./auction.png": 4342,
	"./avax.png": 24015,
	"./avive.png": 61072,
	"./avt.png": 22362,
	"./axs.png": 43323,
	"./azy.png": 51515,
	"./babydoge.png": 87746,
	"./badger.png": 11992,
	"./bal.png": 53804,
	"./band.png": 56648,
	"./bat.png": 7860,
	"./bch.png": 67538,
	"./beth.png": 35298,
	"./bico.png": 58188,
	"./bigtime.png": 55404,
	"./block.png": 87798,
	"./blok.png": 65193,
	"./blur.png": 89882,
	"./bnb.png": 19851,
	"./bnt.png": 5485,
	"./bob.png": 40620,
	"./boba.png": 41071,
	"./bone.png": 75103,
	"./bonk.png": 76433,
	"./bora.png": 61503,
	"./boring.png": 6834,
	"./brwl.png": 14220,
	"./bsv.png": 35116,
	"./btc.png": 10524,
	"./btg.png": 19640,
	"./btt.png": 74947,
	"./bzz.png": 36519,
	"./capo.png": 92310,
	"./ceek.png": 77077,
	"./cel.png": 27741,
	"./celo.png": 40014,
	"./celr.png": 29691,
	"./cetus.png": 12973,
	"./cfg.png": 88195,
	"./cfx.png": 83348,
	"./chz.png": 62040,
	"./city.png": 93356,
	"./ckb.png": 45617,
	"./clv.png": 49640,
	"./comp.png": 17696,
	"./conv.png": 8179,
	"./core.png": 51540,
	"./cream.png": 68359,
	"./cro.png": 86503,
	"./crv.png": 27238,
	"./cspr.png": 97985,
	"./ctc.png": 89805,
	"./ctxc.png": 16759,
	"./cusd.png": 39012,
	"./cvc.png": 56535,
	"./cvp.png": 49036,
	"./cvx.png": 21540,
	"./cxt.png": 86166,
	"./dai.png": 54355,
	"./dao.png": 71909,
	"./dash.png": 42917,
	"./dcr.png": 65002,
	"./degen.png": 62644,
	"./dego.png": 15474,
	"./dent.png": 55046,
	"./dep.png": 2574,
	"./devt.png": 87662,
	"./dgb.png": 42934,
	"./dia.png": 75971,
	"./dmail.png": 3520,
	"./dnt.png": 85587,
	"./dodo.png": 8077,
	"./dog.png": 34643,
	"./doge.png": 24198,
	"./dome.png": 88032,
	"./dora.png": 20437,
	"./dot.png": 60360,
	"./dydx.png": 53252,
	"./egld.png": 44601,
	"./elf.png": 15822,
	"./elon.png": 48065,
	"./elt.png": 34988,
	"./enj.png": 6696,
	"./ens.png": 81049,
	"./eos.png": 92022,
	"./ern.png": 66696,
	"./etc.png": 46363,
	"./eth.png": 43432,
	"./ethfi.png": 9959,
	"./ethw.png": 43573,
	"./eur.png": 98569,
	"./eurt.png": 79337,
	"./fame.png": 55720,
	"./fet.png": 67260,
	"./fil.png": 42064,
	"./fitfi.png": 77959,
	"./flm.png": 45806,
	"./floki.png": 57712,
	"./flow.png": 42393,
	"./flr.png": 11977,
	"./forth.png": 92884,
	"./foxy.png": 67833,
	"./front.png": 60172,
	"./ftm.png": 50070,
	"./fun.png": 77126,
	"./fxs.png": 43180,
	"./g.png": 34278,
	"./gal.png": 2005,
	"./gala.png": 57304,
	"./galft.png": 90771,
	"./gari.png": 82242,
	"./gas.png": 96898,
	"./gear.png": 72156,
	"./gft.png": 81996,
	"./ghst.png": 94941,
	"./glm.png": 75695,
	"./glmr.png": 52429,
	"./gm.png": 36497,
	"./gmt.png": 62017,
	"./gmx.png": 89629,
	"./goal.png": 51828,
	"./gods.png": 11156,
	"./gog.png": 42276,
	"./gpt.png": 99274,
	"./grt.png": 46160,
	"./gtc.png": 95161,
	"./gusd.png": 81184,
	"./hbar.png": 99630,
	"./hnt.png": 98631,
	"./hot.png": 43484,
	"./ice.png": 61736,
	"./icp.png": 73925,
	"./icx.png": 65853,
	"./id.png": 76158,
	"./igu.png": 3884,
	"./ilv.png": 59794,
	"./imx.png": 64471,
	"./inj.png": 94452,
	"./iost.png": 49052,
	"./iota.png": 97552,
	"./iotx.png": 26865,
	"./iq.png": 81235,
	"./joe.png": 30779,
	"./jpg.png": 49420,
	"./jst.png": 26118,
	"./jto.png": 68296,
	"./jup.png": 18724,
	"./kan.png": 4019,
	"./kcal.png": 96092,
	"./kda.png": 91351,
	"./key.png": 57624,
	"./kine.png": 42878,
	"./kishu.png": 14675,
	"./klay.png": 31390,
	"./knc.png": 23783,
	"./kp3r.png": 37567,
	"./ksm.png": 93510,
	"./lamb.png": 98845,
	"./lat.png": 85086,
	"./lbr.png": 59833,
	"./ldo.png": 98470,
	"./leash.png": 48486,
	"./leo.png": 79777,
	"./ling.png": 80121,
	"./link.png": 78885,
	"./lith.png": 60076,
	"./lon.png": 70634,
	"./looks.png": 32545,
	"./lpt.png": 18577,
	"./lqty.png": 58669,
	"./lrc.png": 44592,
	"./lsk.png": 18403,
	"./ltc.png": 826,
	"./luna.png": 93683,
	"./luna2.png": 14793,
	"./lunc.png": 19201,
	"./magic.png": 20000,
	"./mana.png": 25804,
	"./mask.png": 24493,
	"./math.png": 18091,
	"./matic.png": 13155,
	"./mdt.png": 83340,
	"./meme.png": 41657,
	"./mengo.png": 24659,
	"./merl.png": 29305,
	"./metis.png": 74271,
	"./mew.png": 47996,
	"./milo.png": 96180,
	"./mina.png": 29892,
	"./mkr.png": 74403,
	"./mln.png": 9390,
	"./mon.png": 46651,
	"./movez.png": 51822,
	"./movr.png": 65225,
	"./msn.png": 38647,
	"./mtl.png": 93348,
	"./mxc.png": 28983,
	"./myria.png": 26203,
	"./near.png": 70703,
	"./neo.png": 59447,
	"./nft.png": 129,
	"./nmr.png": 28698,
	"./not.png": 53638,
	"./nuls.png": 41005,
	"./nym.png": 13585,
	"./oas.png": 88426,
	"./oax.png": 20409,
	"./okb.png": 27965,
	"./okt.png": 40443,
	"./om.png": 58649,
	"./omg.png": 63122,
	"./omi.png": 32236,
	"./omn.png": 62403,
	"./one.png": 20597,
	"./ong.png": 71559,
	"./ont.png": 74716,
	"./op.png": 64812,
	"./orb.png": 76670,
	"./orbs.png": 36375,
	"./ordi.png": 76587,
	"./oxt.png": 90266,
	"./pax.png": 38214,
	"./pci.png": 22549,
	"./people.png": 40512,
	"./pepe.png": 57733,
	"./perp.png": 46402,
	"./pha.png": 56616,
	"./pokt.png": 32975,
	"./pols.png": 21325,
	"./polydoge.png": 40336,
	"./por.png": 87234,
	"./ppt.png": 97181,
	"./prcl.png": 74978,
	"./prq.png": 71302,
	"./pstake.png": 81503,
	"./pyth.png": 78064,
	"./qtum.png": 72424,
	"./raca.png": 6986,
	"./radar.png": 56725,
	"./rari.png": 55289,
	"./ray.png": 45105,
	"./rdnt.png": 11321,
	"./ren.png": 93682,
	"./render.png": 97825,
	"./rep.png": 76956,
	"./req.png": 94469,
	"./revv.png": 62342,
	"./rio.png": 24239,
	"./rndr.png": 56267,
	"./ron.png": 13104,
	"./rpl.png": 39127,
	"./rsr.png": 14008,
	"./rss3.png": 31326,
	"./runecoin.png": 73114,
	"./rvn.png": 35871,
	"./safe.png": 52742,
	"./samo.png": 26981,
	"./sand.png": 28375,
	"./sats.png": 71406,
	"./sc.png": 23987,
	"./scrt.png": 80233,
	"./sd.png": 24028,
	"./shib.png": 47673,
	"./sis.png": 13702,
	"./skl.png": 10607,
	"./slerf.png": 25051,
	"./sln.png": 55808,
	"./slp.png": 13838,
	"./snt.png": 94832,
	"./snx.png": 56636,
	"./sol.png": 80275,
	"./sos.png": 29604,
	"./spell.png": 21535,
	"./spurs.png": 82842,
	"./srm.png": 98789,
	"./ssv.png": 63005,
	"./sswp.png": 33870,
	"./stc.png": 15421,
	"./steth.png": 96335,
	"./storj.png": 35869,
	"./strk.png": 34845,
	"./stx.png": 54206,
	"./sui.png": 49648,
	"./sun.png": 76143,
	"./sushi.png": 65947,
	"./sweat.png": 82857,
	"./swftc.png": 3326,
	"./t.png": 9229,
	"./tai.png": 70435,
	"./taki.png": 81060,
	"./tama.png": 50606,
	"./tfuel.png": 52957,
	"./theta.png": 60661,
	"./thg.png": 43194,
	"./tia.png": 31955,
	"./tlm.png": 17172,
	"./tnsr.png": 95044,
	"./ton.png": 99474,
	"./tra.png": 79338,
	"./trb.png": 93569,
	"./trx.png": 93819,
	"./tup.png": 81326,
	"./turbo.png": 21369,
	"./tusd.png": 71381,
	"./ulti.png": 31303,
	"./uma.png": 73130,
	"./uni.png": 1267,
	"./usdc.png": 2522,
	"./usdp.png": 89921,
	"./usdt.png": 26213,
	"./ustc.png": 19274,
	"./utk.png": 66803,
	"./uxlink.png": 94810,
	"./vela.png": 62951,
	"./velo.png": 73545,
	"./velodrome.png": 57746,
	"./venom.png": 66398,
	"./vib.png": 14782,
	"./vite.png": 31751,
	"./vra.png": 14352,
	"./w.png": 95254,
	"./waves.png": 17315,
	"./waxp.png": 83461,
	"./wbtc.png": 51065,
	"./wemix.png": 539,
	"./wif.png": 61575,
	"./wifi.png": 9702,
	"./win.png": 68671,
	"./wing.png": 46112,
	"./wld.png": 63198,
	"./wncg.png": 50028,
	"./woo.png": 82524,
	"./wsm.png": 96858,
	"./wxt.png": 63602,
	"./xaut.png": 9207,
	"./xch.png": 61764,
	"./xcn.png": 29202,
	"./xec.png": 48961,
	"./xem.png": 31823,
	"./xeta.png": 57397,
	"./xlm.png": 24568,
	"./xmr.png": 77936,
	"./xno.png": 13540,
	"./xpr.png": 34675,
	"./xr.png": 43319,
	"./xrp.png": 59511,
	"./xtz.png": 4652,
	"./yfi.png": 83303,
	"./ygg.png": 19486,
	"./zbcn.png": 13050,
	"./zec.png": 81807,
	"./zen.png": 70698,
	"./zent.png": 99028,
	"./zero.png": 3763,
	"./zeta.png": 30107,
	"./zeus.png": 8054,
	"./zil.png": 19388,
	"./zk.png": 36040,
	"./zkj.png": 93456,
	"./zro.png": 19962,
	"./zrx.png": 43653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5984;